import "./App.css";
import { useEffect, useState } from "react";

function App() {
  const [otp, setOtp] = useState();

  const handleChange = (e) => {
    setOtp(e.target.value);
  };

  useEffect(() => {
    if ("OTPCredential" in window) {
      const ac = new AbortController();
      navigator.credentials
        .get({
          otp: { transport: ["sms"] },
          signal: ac.signal,
        })
        .then((otp) => {
          console.log(otp?.code);
          setOtp(otp?.code);
          ac.abort();
        })
        .catch((err) => {
          ac.abort();
          console.log(err);
        });
    }
  }, []);

  return (
    <div className="App">
      <h1>Auto Fill OTP</h1>
      <input
        placeholder="Enter OTP Here........."
        value={otp}
        onChange={handleChange}
      />
      <p>OTP : {otp}</p>
    </div>
  );
}

export default App;
